import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallToActionSection() {
  return <section id="call-to-action-section" className="w-full py-20 md:py-28 bg-gradient-to-b from-secondary to-secondary/90 text-secondary-foreground">
      <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center space-y-10">
        <div className="space-y-5 max-w-3xl">
          <h2 className="text-3xl md:text-4xl font-bold font-default leading-tight">Ready to Uncover Your Organisation's Stress Risks?</h2>
          <p className="text-lg font-sans text-secondary-foreground/90 max-w-2xl mx-auto">
            Take the first step towards a healthier workplace. Identify hidden stressors and build a more resilient culture today.
          </p>
        </div>

        <div className="flex flex-col items-center space-y-6">
          <Button asChild size="lg" className="bg-primary text-white hover:bg-primary/90 hover:scale-[1.02] transition-transform duration-200 text-base font-semibold px-8 h-14 rounded-md shadow-lg">
            <Link to="#">Book a Demo Now</Link>
          </Button>

          <Link to="#" className="inline-flex items-center justify-center text-secondary-foreground underline decoration-chart-3 decoration-2 underline-offset-8 hover:decoration-white transition-colors duration-200 font-medium text-base">
            Book a discovery call
          </Link>
        </div>
      </div>
    </section>;
}